module.exports = __webpack_public_path__ + "img/d11.4666fcd1.png";